import { HttpInterceptorFn, HttpContextToken, HttpContext } from "@angular/common/http"; // Import HttpContextToken, HttpContext
import { inject } from "@angular/core";
import { finalize } from "rxjs";
import { LoaderService } from "@core/services/gigya/loader/loader.service";

// Define the HttpContextToken for controlling the loader
export const SHOW_LOADER = new HttpContextToken<boolean>(() => true); // Default to true if not provided

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  // Check the context to decide whether to show the loader
  const showLoader = req.context.get(SHOW_LOADER);

  if (showLoader) { // Only show loader if SHOW_LOADER is true in context
    loaderService.show();
    return next(req).pipe(
      finalize(() => loaderService.hide())
    );
  } else { // If SHOW_LOADER is false, just proceed with the request without showing loader
    return next(req);
  }
};